module.exports = __webpack_public_path__ + "img/trash.b5cc429c.svg";